const SequenceTimeMeasurementsFooter = () =>
  import('frontend/presentation/standards/time-measurements/views/sequence-time-measurements/footer/SequenceTimeMeasurementsFooter.vue')
const SequenceTimeMeasurementsLeadingHeader = () =>
  import('frontend/presentation/standards/time-measurements/views/sequence-time-measurements/headers/leading-header/SequenceTimeMeasurementsLeadingHeader.vue')
const SequenceTimeMeasurementsList = () =>
  import('frontend/presentation/standards/time-measurements/views/sequence-time-measurements/measurements-list/SequenceTimeMeasurementsList.vue')
const SequenceTimeMeasurementsTrailingHeader = () =>
  import('frontend/presentation/standards/time-measurements/views/sequence-time-measurements/headers/trailing-header/SequenceTimeMeasurementsTrailingHeader.vue')
const StandardTimeMeasurements = () =>
  import('frontend/presentation/standards/time-measurements/views/standard-time-measurements/StandardTimeMeasurements.vue')
const StandardTimeMeasurementsLeadingHeader = () =>
  import('frontend/presentation/standards/time-measurements/views/standard-time-measurements/headers/leading-header/StandardTimeMeasurementsLeadingHeader.vue')
const StandardTimeMeasurementsList = () =>
  import('frontend/presentation/standards/time-measurements/measurement-list/views/StandardTimeMeasurementsList.vue')
const StandardTimeMeasurementsNavigation = () =>
  import('frontend/presentation/standards/time-measurements/views/standard-time-measurements/navigation/StandardTimeMeasurementsNavigation.vue')

import { DASHBOARD_MODULE_TOKENS } from 'frontend/constants/settings'

const standardIdParser = (router) => {
  return { standardId: Number(router.params.standardId) }
}

const isHeightFixed = (router) => {
  return { isHeightFixed: DASHBOARD_MODULE_TOKENS.sequenceTimeMeasurementsList.name === router.name }
}

export default [
  {
    shownInMenu: false,
    path: ':standardId/time-measurements/',
    components: {
      default: StandardTimeMeasurements,
    },
    props: {
      default: (router) => ({
        ...standardIdParser(router),
        ...isHeightFixed(router),
      }),
    },
    children: [
      {
        path: '',
        name: DASHBOARD_MODULE_TOKENS.standardTimeMeasurementsList.name,
        components: {
          default: StandardTimeMeasurementsList,
          navigation: StandardTimeMeasurementsNavigation,
          leadingHeader: StandardTimeMeasurementsLeadingHeader,
        },
        props: {
          default: standardIdParser,
          navigation: standardIdParser,
          leadingHeader: standardIdParser,
        },
      },
      {
        path: 'new',
        name: DASHBOARD_MODULE_TOKENS.sequenceTimeMeasurementsList.name,
        components: {
          default: SequenceTimeMeasurementsList,
          footer: SequenceTimeMeasurementsFooter,
          leadingHeader: SequenceTimeMeasurementsLeadingHeader,
          trailingHeader: SequenceTimeMeasurementsTrailingHeader,
        },
        props: {
          default: standardIdParser,
          footer: standardIdParser,
          leadingHeader: standardIdParser,
          trailingHeader: standardIdParser,
        },
      },
    ],
  },
]
